import {
  Button,
  Icon,
  SearchField,
  styled,
  TableCell,
  TableRow,
  CircularProgress,
  LinearProgress,
  Typography,
} from '@nextiva/next-ui-components';
import { SvgCircularClose, SvgExclamationTriangle } from 'components/SvgIcon';
import { GrayIcon } from './DataImport.styles';

export const HistorySearch = styled(SearchField)`
  input.MuiOutlinedInput-input.MuiInputBase-input {
    width: 330px;
  }
  margin-bottom: 50px;
`;

export const DownloadIcon = styled(GrayIcon)`
  margin: 8px 12px 0px;
  cursor: pointer;
`;

export const ImportButton = styled(Button)`
  margin-left: 10px;
  margin-right: 2px;
  height: 40px;
  border-radius: 4px;
`;

export const HistoryTableRow = styled(TableRow)`
  position: relative;
`;

export const StyledStatusCell = styled(TableCell)`
  min-width: 280px;
`;
export const StyledTableCell = styled(TableCell)`
  word-break: break-all;
`;
export const StyledDateTableCell = styled(TableCell)`
  min-width: 151px;
`;
export const StyledBox = styled('div')`
  display: flex;
  align-items: center;
`;
export const MenuIcon = styled(GrayIcon)`
  position: absolute;
  visibility: hidden;
`;

export const CompletedIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.success.main};
  margin-right: 10px;
`;

export const CompletedWithErrorsIcon = styled(SvgExclamationTriangle)`
  color: ${({ theme }) => theme.palette.orange['400']};
  margin-right: 10px;
  width: 16px;
  height: 16px;
  font-size: 16px;
`;

export const FailedIcon = styled(SvgCircularClose)`
  fill: ${({ theme }) => theme.palette.pink[700]};
  margin-right: 10px;
  width: 16px;
  height: 16px;
  font-size: 16px;
`;

export const CancelledIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.pink[700]};
  margin-right: 10px;
`;

export const LoadingIcon = styled(CircularProgress)`
  width: 16px !important;
  height: 16px !important;
  margin-right: 10px;
`;

export const ProgressBar = styled(LinearProgress)`
  width: 161px;
  height: 6px;
  background-color: ${({ theme }) => theme.palette.blue[50]};
`;

export const StyledProgressBarText = styled(Typography)`
  margin-left: 16px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
  font-weight: 800;
`;
